export default __webpack_public_path__ + "static/media/Helm of Vehement Thunder.977a848b.jpg";